<template>
  <div class="panel panel-default text-left">
    <!-- Default panel contents -->
    <div class="panel-heading">
      <label for="" class="form-check-label">
        <!-- v-bind.prop="getIndeterminate" -->
        <input
          type="checkbox"
          class="form-check-input"
          disabled
          :checked="getFieldValue(`is_${animalType}`, 'ClientDetails')"
        />
        {{ animalTypeDisplay }}
      </label>

      <create-animal-form
        :animal-type="animalType"
        v-if="!isReadOnly"
        @animal-created="updateConsultTypesEnabled"
      ></create-animal-form>
    </div>

    <!-- List group -->
    <ul class="list-group">
      <li v-for="animal in animals(animalType)" :key="`${animalType}-${animal.name}`" class="list-group-item">
        <check-box
          :label="animal.name"
          @on-change="updateConsultTypesEnabled"
          :field-name="`animal_${animal.id}-is_consult_animal`"
          modelName="ClientDetails"
          style="margin-bottom: 0"
        >
        </check-box>
      </li>

      <li
        v-for="(animal, index) in newAnimals(animalType)"
        :key="`${animalType}-${animal.name}-${index}`"
        class="list-group-item"
      >
        <input type="checkbox" checked="checked" disabled="disabled" />
        {{ animal.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { capitalize, unslugify } from '@/_helpers'
import CheckBox from '@/components/inputs/CheckBox'
import CreateAnimalForm from '@/components/general_farm_consult/_/CreateAnimalForm'

export default {
  name: 'AnimalTypeSection',
  props: ['animalType'],
  components: { CheckBox, CreateAnimalForm },
  computed: {
    ...mapGetters('currentConsult', ['animals', 'getFieldValue', 'isReadOnly', 'newAnimals', 'enabledAnimals']),
    animalTypeDisplay: function () {
      return capitalize(unslugify(this.animalType))
    },
    getIndeterminate: function () {
      return {
        indeterminate: Boolean(this.hasNewAnimals(this.animalType) && !this.consultAnimalInfo.every((d) => d)),
      }
    },
    consultAnimalInfo: function () {
      return this.animals(this.animalType).map((a) => a.is_consult_animal)
    },
  },
  methods: {
    ...mapActions('currentConsult', ['setFieldValue']),
    hasAnimals: function () {
      return Object.keys(this.animals(this.animalType, true)).length > 0
    },
    hasNewAnimals: function () {
      return this.newAnimals(this.animalType).length > 0
    },
    updateConsultTypesEnabled: function () {
      // update wether or not animalType steps should be enabled
      this.setFieldValue({
        fieldName: `is_${this.animalType}`,
        value: this.enabledAnimals(this.animalType).length > 0,
        modelName: 'ClientDetails',
      })
    },
  },
}
</script>
